import React, { useEffect, useRef, useState } from "react";
import SVG from "react-inlinesvg";
import { Dialog } from "@material-ui/core";
import { Toolbar } from "@material-ui/core";
import { IconButton } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { List } from "@material-ui/core";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import TransactionIcon from "../../_assets/plugins/keenthemes-icons/svg/Transaction_Icon.png";
import AddPrizeImg from "../../_assets/plugins/keenthemes-icons/svg/buttonImg.png";
import StoreHomeImg from "../../_assets/plugins/keenthemes-icons/svg/home-icon.png";
import StorePlusIcon from "../../_assets/plugins/keenthemes-icons/svg/Plus-icon.png";
import StoreIconDetails from "../../_assets/plugins/keenthemes-icons/svg/store-icon-details.png";
import EditUser from "../../_assets/plugins/keenthemes-icons/svg/editIcon.png";
import "react-image-crop/src/ReactCrop.scss";
import { toAbsoluteUrl } from "../../_helpers";

function AddStore(props) {
  const {
    addStore,
    addStoreModelClose,
    isEditApi,
    userInfo,
    storeData,
    onhandleChange,
    userData,
    errors,
    handleOnChnageAddImg,
    setphoneInput,
    phoneInput,
    onhandleMonthChange,
    onhandlecustometabChange,
    monthDay,
    handleClickedMap,
    longtitude,
    MyMapComponent,
    addStoreData,
    editStoreData,
    loader,
    latitude,
    setStoreData,
  } = props;

  const modalRef = useRef(null);

  return (
    <Dialog fullScreen open={addStore}>
      <Toolbar>
        <IconButton edge="start" color="inherit" onClick={(e) => addStoreModelClose(e)} aria-label="close">
          <CloseIcon />
        </IconButton>
      </Toolbar>
      <div ref={modalRef} style={{ height: `calc(100dvh - 64px)`, overflowY: "auto" }}>
        <List>
          <div className="heading-banner d-flex justify-content-center">
            <div className="align-items-center d-flex">
              {isEditApi === true ? (
                <img src={EditUser} alt="EditUser" className="coupon mr-4" />
              ) : (
                <img src={StorePlusIcon} alt="StorePlusIcon" className="plusImg mr-4" />
              )}

              <img src={TransactionIcon} alt="TransactionIcon" className="exchangeImg" />
            </div>
          </div>
          <div className="m-auto w-1000px pt-10">
            {userInfo?.role === "admin" && isEditApi === false && (
              <div className="form-group row">
                <label className="col-xl-5 col-lg-5 col-form-label label-alignment">User</label>
                <div className="col-lg-7 col-xl-7">
                  <div>
                    <select
                      name="userId"
                      id="userId"
                      defaultValue={storeData?.userId}
                      className="form-control rounded-lg custom-style"
                      aria-label="Default select example"
                      onChange={(e) => onhandleChange(e)}
                    >
                      <option selected disabled>
                        Select user
                      </option>
                      {userData && userData?.map((data) => <option value={data._id}>{data?.username}</option>)}
                    </select>

                    <span
                      style={{
                        color: "red",
                        top: "5px",
                        fontSize: "12px",
                      }}
                    >
                      {errors["userId"]}
                    </span>
                  </div>
                </div>
              </div>
            )}
            <div className="form-group row">
              <label className="col-xl-5 col-lg-5 col-form-label label-alignment">Name</label>
              <div className="col-lg-7 col-xl-7">
                <div>
                  <input
                    type="text"
                    className={`form-control rounded-lg custom-style`}
                    id="title"
                    name="name"
                    value={storeData?.name}
                    onChange={(e) => {
                      onhandleChange(e);
                    }}
                  />
                </div>
                <span
                  style={{
                    color: "red",
                    top: "5px",
                    fontSize: "12px",
                  }}
                >
                  {errors["name"]}
                </span>
              </div>
            </div>
            <div className="form-group row">
              <label className="col-xl-5 col-lg-5 col-form-label label-alignment">
                Thumb nail Image
                <p style={{ fontSize: "11px", color: "black", fontWeight: "bold" }}>1:1 aspect ratio</p>
              </label>
              <div className="col-lg-7 col-xl-7">
                <div>
                  <div className="labelMainDiv">
                    <label htmlFor="uploadStoreImage" className="lableForImage">
                      select file
                    </label>
                    {storeData?.storeImage ? "" : <label className="labelselectfile">no file selected</label>}
                  </div>
                  <input
                    type="file"
                    className={`form-control form-control-lg form-control-solid`}
                    name="storeImage"
                    id="uploadStoreImage"
                    hidden
                    onChange={(e) => handleOnChnageAddImg(e)}
                  />
                </div>

                <div>
                  {storeData?.storeImage && (
                    <img
                      // style={{
                      // height: "150px",
                      // width: "270px",
                      // margin: "15px 0",
                      // }}
                      src={
                        storeData?.storeImage?.toString()?.includes(".com") === true
                          ? storeData?.storeImage
                          : URL.createObjectURL(storeData?.storeImage)
                      }
                    />
                  )}
                </div>
                <span
                  style={{
                    color: "red",
                    top: "5px",
                    fontSize: "12px",
                  }}
                >
                  {errors["storeImage"]}
                </span>
              </div>
            </div>
            <div className="form-group row">
              <label className="col-xl-5 col-lg-5 col-form-label label-alignment">
                Banner Image
                <p style={{ fontSize: "11px", color: "black", fontWeight: "bold" }}>2:1 aspect ratio</p>
              </label>

              <div className="col-lg-7 col-xl-7">
                <div>
                  <div className="labelMainDiv">
                    <label htmlFor="storeImageThumbnail" className="lableForImage">
                      select file
                    </label>
                    {storeData?.storeImage ? "" : <label className="labelselectfile">no file selected</label>}
                  </div>
                  <input
                    type="file"
                    className={`form-control form-control-lg form-control-solid`}
                    name="storeImageThumbnail"
                    id="storeImageThumbnail"
                    hidden
                    onChange={(e) => handleOnChnageAddImg(e)}
                  />
                </div>
                <div>
                  {storeData?.storeImageThumbnail?.length !== 0 && (
                    <img
                      style={{
                        height: "150px",
                        width: "270px",
                        margin: "15px 0",
                      }}
                      src={
                        storeData?.storeImageThumbnail instanceof File
                          ? URL.createObjectURL(storeData.storeImageThumbnail)
                          : typeof storeData?.storeImageThumbnail === "string"
                          ? storeData.storeImageThumbnail
                          : ""
                      }
                    />
                  )}
                </div>
                <span
                  style={{
                    color: "red",
                    top: "5px",
                    fontSize: "12px",
                  }}
                >
                  {errors["storeImage"]}
                </span>
              </div>
            </div>
            <div className="form-group row align-items-center">
              <label htmlFor="coinIcon" className="col-xl-3 col-lg-3 col-form-label">
                <img src={StoreIconDetails} alt="StoreIconDetails" className="storeImg1" />
              </label>
              <div className="col-lg-9 col-xl-6">
                <div>
                  <input
                    type="checkbox"
                    className={`form-control form-control-lg form-control-solid `}
                    id="coinIcon"
                    name="coinIcon"
                    value={storeData?.coinIcon}
                    defaultChecked={storeData?.coinIcon}
                    onChange={(e) => onhandleChange(e)}
                  />
                </div>
                <span
                  style={{
                    color: "red",
                    top: "5px",
                    fontSize: "12px",
                  }}
                >
                  {errors["coinIcon"]}
                </span>
              </div>
            </div>
            <div className="form-group row align-items-center">
              <div htmlFor="delivery" className="col-xl-3 col-lg-3 col-form-label">
                <label className="deleviryBoxAlignment">DELIVERY</label>
              </div>
              <div className="col-lg-9 col-xl-6">
                <div>
                  <input
                    type="checkbox"
                    className={`form-control form-control-lg form-control-solid `}
                    id="delivery"
                    name="delivery"
                    value={storeData?.delivery}
                    defaultChecked={storeData?.delivery}
                    onChange={(e) => onhandleChange(e)}
                  />
                </div>
                <span
                  style={{
                    color: "red",
                    top: "5px",
                    fontSize: "12px",
                  }}
                >
                  {errors["delivery"]}
                </span>
              </div>
            </div>
            <div className="form-group row align-items-center">
              <div htmlFor="digital" className="col-xl-3 col-lg-3 col-form-label">
                <label className="deleviryBoxAlignment digital">digital</label>
              </div>
              <div className="col-lg-9 col-xl-6 align-items-center">
                <div>
                  <input
                    type="checkbox"
                    className={`form-control form-control-lg form-control-solid `}
                    id="digital"
                    name="digital"
                    value={storeData?.digital}
                    defaultChecked={storeData?.digital}
                    onChange={(e) => onhandleChange(e)}
                  />
                </div>
                <span
                  style={{
                    color: "red",
                    top: "5px",
                    fontSize: "12px",
                  }}
                >
                  {errors["digital"]}
                </span>
              </div>
            </div>
            <div className="form-group row align-items-center">
              <div htmlFor="brickandmortar" className="col-xl-3 col-lg-3 col-form-label">
                <label className="deleviryBoxAlignment mortar">brickandmortar</label>
              </div>
              <div className="col-lg-9 col-xl-6">
                <div>
                  <input
                    type="checkbox"
                    className={`form-control form-control-lg form-control-solid `}
                    id="brickandmortar"
                    name="brickandmortar"
                    value={storeData?.brickandmortar}
                    defaultChecked={storeData?.brickandmortar}
                    onChange={(e) => onhandleChange(e)}
                  />
                </div>
                <span
                  style={{
                    color: "red",
                    top: "5px",
                    fontSize: "12px",
                  }}
                >
                  {errors["brickandmortar"]}
                </span>
              </div>
            </div>
            <div className="form-group row">
              <label htmlFor="coinIcon" className="col-xl-5 col-lg-5 col-form-label label-alignment">
                Is-Featured
              </label>
              <div className="col-lg-7 col-xl-7">
                <div>
                  <input
                    type="checkbox"
                    className={`form-control form-control-lg `}
                    id="isFeatured"
                    name="isFeatured"
                    value={storeData?.isFeatured}
                    defaultChecked={storeData?.isFeatured}
                    onChange={(e) => onhandleChange(e)}
                  />
                </div>
                <span
                  style={{
                    color: "red",
                    top: "5px",
                    fontSize: "12px",
                  }}
                >
                  {errors["isFeatured"]}
                </span>
              </div>
            </div>
            <div className="form-group row">
              <label className="col-xl-5 col-lg-5 col-form-label label-alignment">E-mail</label>
              <div className="col-lg-7 col-xl-7">
                <div>
                  <input
                    type="email"
                    className={`form-control rounded-lg custom-style`}
                    id="email"
                    name="email"
                    value={storeData?.email}
                    onChange={(e) => {
                      onhandleChange(e);
                    }}
                  />
                </div>
                <span
                  style={{
                    color: "red",
                    top: "5px",
                    fontSize: "12px",
                  }}
                >
                  {errors["email"]}
                </span>
              </div>
            </div>
            <div className="form-group row">
              <label className="col-xl-5 col-lg-5 col-form-label label-alignment">Url</label>
              <div className="col-lg-7 col-xl-7">
                <div>
                  <input
                    type="text"
                    className={`form-control rounded-lg custom-style`}
                    id="url"
                    name="url"
                    value={storeData?.url}
                    onChange={(e) => {
                      onhandleChange(e);
                    }}
                  />
                </div>
                <span
                  style={{
                    color: "red",
                    top: "5px",
                    fontSize: "12px",
                  }}
                >
                  {errors["url"]}
                </span>
              </div>
            </div>
            <div className="form-group row">
              <label className="col-xl-5 col-lg-5 col-form-label label-alignment">Phone</label>
              <div className="col-lg-7 col-xl-7">
                <div>
                  <PhoneInput
                    placeholder="Enter Phone Number"
                    name="phone"
                    maxLength="18"
                    value={phoneInput}
                    onChange={(e) => {
                      setphoneInput(e);
                    }}
                  />
                </div>

                <span
                  style={{
                    color: "red",
                    top: "5px",
                    fontSize: "12px",
                  }}
                >
                  {errors["phone"]}
                </span>
              </div>
            </div>
            <div className="form-group row">
              <label className="col-xl-5 col-lg-5 col-form-label label-alignment">Detail</label>
              <div className="col-lg-7 col-xl-7">
                <div>
                  <input
                    type="text"
                    className={`form-control rounded-lg custom-style`}
                    id="details"
                    name="details"
                    value={storeData?.details}
                    onChange={(e) => {
                      onhandleChange(e);
                    }}
                  />
                </div>
                <span
                  style={{
                    color: "red",
                    top: "5px",
                    fontSize: "12px",
                  }}
                >
                  {errors["details"]}
                </span>
              </div>
            </div>
            <div className="form-group row">
              <label className="col-xl-5 col-lg-5 col-form-label label-alignment">Description</label>
              <div className="col-lg-7 col-xl-7">
                <div>
                  <input
                    type="text"
                    className={`form-control rounded-lg custom-style`}
                    id="description"
                    name="description"
                    value={storeData?.description}
                    onChange={(e) => {
                      onhandleChange(e);
                    }}
                  />
                </div>
                <span
                  style={{
                    color: "red",
                    top: "5px",
                    fontSize: "12px",
                  }}
                >
                  {errors["description"]}
                </span>
              </div>
            </div>
            {storeData?.brickandmortar === true && (
              <>
                <div className="form-group row">
                  <label className="col-xl-5 col-lg-5 col-form-label label-alignment">Address</label>
                  <div className="col-lg-7 col-xl-7">
                    <div>
                      <input
                        type="text"
                        className={`form-control rounded-lg custom-style`}
                        id="address"
                        name="address"
                        value={storeData?.address}
                        onChange={(e) => {
                          onhandleChange(e);
                        }}
                      />
                    </div>
                    <span
                      style={{
                        color: "red",
                        top: "5px",
                        fontSize: "12px",
                      }}
                    >
                      {errors["address"]}
                    </span>
                  </div>
                </div>

                <div className="form-group row">
                  <label className="col-xl-5 col-lg-5 col-form-label label-alignment">State</label>
                  <div className="col-lg-7 col-xl-7">
                    <div>
                      <input
                        type="text"
                        className={`form-control rounded-lg custom-style`}
                        id="state"
                        name="state"
                        value={storeData?.state}
                        onChange={(e) => {
                          onhandleChange(e);
                        }}
                      />
                    </div>
                    <span
                      style={{
                        color: "red",
                        top: "5px",
                        fontSize: "12px",
                      }}
                    >
                      {errors["state"]}
                    </span>
                  </div>
                </div>

                <div className="form-group row">
                  <label className="col-xl-5 col-lg-5 col-form-label label-alignment">Zip Code</label>
                  <div className="col-lg-7 col-xl-7">
                    <div>
                      <input
                        type="number"
                        className={`form-control rounded-lg custom-style`}
                        id="zipCode"
                        name="zipCode"
                        value={storeData?.zipCode}
                        onChange={(e) => {
                          onhandleChange(e);
                        }}
                      />
                    </div>
                    <span
                      style={{
                        color: "red",
                        top: "5px",
                        fontSize: "12px",
                      }}
                    >
                      {errors["zipCode"]}
                    </span>
                  </div>
                </div>

                <div className="form-group row">
                  <label className="col-xl-5 col-lg-5 col-form-label label-alignment">city</label>
                  <div className="col-lg-7 col-xl-7">
                    <div>
                      <input
                        type="text"
                        className={`form-control rounded-lg custom-style`}
                        id="city"
                        name="city"
                        value={storeData?.city}
                        onChange={(e) => {
                          onhandleChange(e);
                        }}
                      />
                    </div>
                    <span
                      style={{
                        color: "red",
                        top: "5px",
                        fontSize: "12px",
                      }}
                    >
                      {errors["city"]}
                    </span>
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-xl-5 col-lg-5 col-form-label label-alignment">country</label>
                  <div className="col-lg-7 col-xl-7">
                    <div>
                      <input
                        type="text"
                        className={`form-control rounded-lg custom-style`}
                        id="country"
                        name="country"
                        value={storeData?.country}
                        onChange={(e) => {
                          onhandleChange(e);
                        }}
                      />
                    </div>
                    <span
                      style={{
                        color: "red",
                        top: "5px",
                        fontSize: "12px",
                      }}
                    >
                      {errors["country"]}
                    </span>
                  </div>
                </div>
              </>
            )}
            <div className="form-group row">
              <label className="col-xl-5 col-lg-5 col-form-label label-alignment">Opening hour</label>
              <div className="col-lg-7 col-xl-7">
                <div className="d-flex justify-content-between mb-4">
                  <label htmlFor="customHours24">24/7</label>
                  <div className="col-lg-7 col-xl-7">
                    <input
                      type="radio"
                      className={`form-control form-control-lg `}
                      id="customHours24"
                      name="customHours"
                      value="24/7"
                      checked={storeData?.customHoursType === "24/7"}
                      onChange={(e) =>
                        setStoreData({
                          ...storeData,
                          customHours: false,
                          customHoursType: "24/7",
                        })
                      }
                    />
                  </div>
                </div>
                <div className="d-flex justify-content-between mb-4">
                  <label htmlFor="customHours">Customed</label>
                  <div className="col-lg-7 col-xl-7">
                    <input
                      type="radio"
                      className={`form-control form-control-lg `}
                      id="customHours"
                      name="customHours"
                      value="Customed"
                      checked={storeData?.customHoursType === "Customed"}
                      onChange={(e) =>
                        setStoreData({
                          ...storeData,
                          customHours: true,
                          customHoursType: "Customed",
                        })
                      }
                    />
                  </div>
                </div>
                <div className="d-flex justify-content-between mb-2">
                  <label htmlFor="customHoursAppointment">By Appointment Only</label>
                  <div className="col-lg-7 col-xl-7">
                    <input
                      type="radio"
                      className={`form-control form-control-lg`}
                      id="customHoursAppointment"
                      name="customHours"
                      value="ByAppointment"
                      checked={storeData?.customHoursType === "ByAppointment"}
                      onChange={(e) =>
                        setStoreData({
                          ...storeData,
                          customHours: false,
                          customHoursType: "ByAppointment",
                        })
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
            <span
              style={{
                color: "red",
                top: "5px",
                fontSize: "12px",
              }}
            >
              {errors["customHours"]}
            </span>
            {storeData?.customHours === true || storeData?.customHours == "Customed" ? (
              <>
                {monthDay?.map((item, i) => {
                  return (
                    <div className="d-flex justify-content-between">
                      <div>
                        <h3>{item?.day}</h3>
                      </div>
                      <div className="d-flex">
                        {item?.open === "" && item?.close === "" && (
                          <>
                            <input
                              type="checkbox"
                              className={`form-control rounded-lg custom-style`}
                              id={item?.day}
                              name={item?.day}
                              value={item?.day}
                              checked={item?.closed}
                              onChange={(e) => {
                                onhandlecustometabChange(e, i);
                              }}
                            />
                            <h3>closed</h3>
                          </>
                        )}

                        {!item?.closed && (
                          <>
                            <input
                              type="time"
                              className={`form-control rounded-lg custom-style`}
                              name="open"
                              value={item?.open}
                              onChange={(e) => {
                                onhandleMonthChange(e, i);
                              }}
                            />
                            <input
                              type="time"
                              className={`form-control rounded-lg custom-style`}
                              name="close"
                              value={item?.close}
                              onChange={(e) => {
                                onhandleMonthChange(e, i);
                              }}
                            />
                          </>
                        )}

                        <span
                          style={{
                            color: "red",
                            top: "5px",
                            fontSize: "12px",
                          }}
                        >
                          {errors[`closed${i}`]}
                        </span>
                      </div>
                    </div>
                  );
                })}
              </>
            ) : (
              ""
            )}
            <div className="form-group row">
              <div className="col-xs-12 col-lg-12">
                <div className="my-12">
                  <MyMapComponent key="map" longtitude={longtitude || 0} latitude={latitude || 0} handleClickedMap={(e) => handleClickedMap(e)} />
                </div>
              </div>
            </div>
            <div className="form-group row">
              <label className="col-xl-5 col-lg-5 col-form-label label-alignment">latitude</label>
              <div className="col-lg-7 col-xl-7">
                <div>
                  <input
                    type="number"
                    className={`form-control rounded-lg custom-style`}
                    id="lat"
                    name="lat"
                    value={latitude}
                    onChange={(e) => {
                      onhandleChange(e);
                    }}
                  />
                </div>
                <span
                  style={{
                    color: "red",
                    top: "5px",
                    fontSize: "12px",
                  }}
                >
                  {errors["lat"]}
                </span>
              </div>
            </div>
            <div className="form-group row">
              <label className="col-xl-5 col-lg-5 col-form-label label-alignment">longitude</label>
              <div className="col-lg-7 col-xl-7">
                <div>
                  <input
                    type="number"
                    className={`form-control rounded-lg custom-style`}
                    id="long"
                    name="long"
                    value={longtitude}
                    onChange={(e) => {
                      onhandleChange(e);
                    }}
                  />
                </div>
                <span
                  style={{
                    color: "red",
                    top: "5px",
                    fontSize: "12px",
                  }}
                >
                  {errors["long"]}
                </span>
              </div>
            </div>
            {isEditApi === true && (
              <div className="form-group row">
                <label className="col-xl-5 col-lg-5 col-form-label label-alignment">Status</label>
                <div className="col-lg-7 col-xl-7">
                  {userInfo?.role === "admin" ? (
                    <div>
                      <select
                        className={`form-control form-control-lg form-control-solid `}
                        onChange={(e) => {
                          onhandleChange(e);
                        }}
                        name="status"
                        defaultValue={storeData?.status}
                      >
                        <option value="select for status" selected disabled>
                          select Status
                        </option>
                        <option value="pushToTop">Push To Top</option>
                        <option value="active">Active</option>
                        <option value="suspended">Suspended</option>
                      </select>
                    </div>
                  ) : (
                    <div>
                      <select
                        className={`form-control form-control-lg form-control-solid `}
                        onChange={(e) => {
                          onhandleChange(e);
                        }}
                        name="status"
                        defaultValue={storeData?.status}
                      >
                        <option value="select for status" selected disabled>
                          select Status
                        </option>
                        <option value="active">Active</option>
                        <option value="deactivated">De-Active</option>
                      </select>
                    </div>
                  )}
                  <span
                    style={{
                      color: "red",
                      top: "5px",
                      fontSize: "12px",
                    }}
                  >
                    {errors["status"]}
                  </span>
                </div>
              </div>
            )}
            {/* <div className="form-group row">
                <label className="col-xl-5 col-lg-5 col-form-label label-alignment">
                  Open Time
                </label>
                <div className="col-lg-7 col-xl-7">
                  <div>
                    <input
                      type="time"
                      className={`form-control rounded-lg custom-style`}
                      id="openTime"
                      name="openTime"
                      value={storeData?.openTime}
                      onChange={(e) => {
                        onhandleChange(e);
                      }}
                    />
                  </div>
                  <span
                    style={{
                      color: "red",
                      top: "5px",
                      fontSize: "12px",
                    }}
                  >
                    {errors["openTime"]}
                  </span>
                </div>
              </div>

              <div className="form-group row">
                <label className="col-xl-5 col-lg-5 col-form-label label-alignment">
                  Close Time
                </label>
                <div className="col-lg-7 col-xl-7">
                  <div>
                    <input
                      type="time"
                      className={`form-control rounded-lg custom-style`}
                      id="closeTime"
                      name="closeTime"
                      value={storeData?.closeTime}
                      onChange={(e) => {
                        onhandleChange(e);
                      }}
                    />
                  </div>
                  <span
                    style={{
                      color: "red",
                      top: "5px",
                      fontSize: "12px",
                    }}
                  >
                    {errors["closeTime"]}
                  </span>
                </div>
              </div> */}
          </div>

          <div className="d-flex justify-content-center">
            {loader ? (
              <>
                <div className="text-center button-details-alignment">
                  <button className="btn position-relative center" type="button">
                    <img src={AddPrizeImg} alt={AddPrizeImg} />
                    <img src={StoreHomeImg} alt="StoreHomeImg" className="add-prizes-child-img" />
                    {isEditApi ? "Edit  Store" : "Add Store"}
                    <span className="mx-3 spinner spinner-black" role="status"></span>
                  </button>
                </div>
              </>
            ) : (
              <div className="button-details-alignment">
                <button
                  className="btn position-relative center"
                  onClick={(e) => {
                    isEditApi ? editStoreData(e) : addStoreData(e);
                  }}
                >
                  <img src={AddPrizeImg} alt={AddPrizeImg} />
                  <img src={StoreHomeImg} alt="StoreHomeImg" className="add-prizes-child-img" />
                  {isEditApi ? "Edit  Store" : "Add Store"}
                </button>
              </div>
            )}
          </div>
        </List>

        <BackToTop modalRef={modalRef} />
      </div>
    </Dialog>
  );
}

export default AddStore;

const BackToTop = (props) => {
  const [isVisible, setIsVisible] = useState(false);

  const handleScrollToTop = () => {
    props.modalRef.current.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    const modalElement = props.modalRef.current;

    const toggleVisibility = () => {
      if (modalElement) {
        setIsVisible(modalElement.scrollTop >= 220);
      }
    };

    if (modalElement) {
      modalElement.addEventListener("scroll", toggleVisibility);
      toggleVisibility();
    }

    return () => {
      if (modalElement) {
        modalElement.removeEventListener("scroll", toggleVisibility);
      }
    };
  }, [props.modalRef]);

  return (
    isVisible && (
      <div id="scroll-to-top" className={`scroll-to-top-button-modal`}>
        <span className="svg-icon" onClick={handleScrollToTop}>
          <SVG src={toAbsoluteUrl("/media/svg/icons/Navigation/Up-2.svg")}></SVG>
        </span>
      </div>
    )
  );
};
